import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { IToolbarItem } from '@shared/interfaces/toolbar-item.interface';
import { subMenuItems } from '../submenu';
import { Table, TableLazyLoadEvent } from 'primeng/table';
import { debounceTime, distinctUntilChanged, firstValueFrom, Subject } from 'rxjs';
import { ApiService } from '@shared/services/api.service';
import { UtilsService } from '@shared/services/utils.service';
import { environment } from 'src/environments/environment';
import { TokenService } from '@shared/services/token.service';
import { HttpParams } from '@angular/common/http';
import { PaymentsMenuService } from '@shared/services/payments-menu.service';

@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.scss']
})

export class InvoicesComponent {

  @ViewChild(Table) dt!: Table;
  public subMenuItems: Array<IToolbarItem> = [];
  public searcherCriteria: string = '';
  public loading: boolean = false;
  public filteredInvoices: any[] = [];
  public totalRecords: number = 0;
  private searchSubject = new Subject<string>();
  public currentPage: number = 0;


  constructor(
    private apiService: ApiService,
    public utils: UtilsService,
    private tokenService: TokenService,
    private cdr: ChangeDetectorRef,
    private subMenuService: PaymentsMenuService

  ) { }

  ngOnInit(): void {
    this.subMenuItems = this.subMenuService.getSubMenuItems();
    this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(searchText => {
      this.filterResults(searchText);
    });
    this.loadInvoices({ first: 0 });
  }

  filterResults(searchText: string) {
    this.dt.clear();
    if (searchText.trim() == '') {
      this.searcherCriteria = '';
    }
    this.loadInvoices();
  }

  async loadInvoices(event?: TableLazyLoadEvent) {
    this.totalRecords = 0;
    this.loading = true;
    if (event) {
      this.currentPage = Number((event?.first === 0 || event?.first == undefined) ? 1 : event.first / (event.rows == undefined ? 1 : event.rows) + 1);
    }
    let res: any = await firstValueFrom(this.apiService.getInvoicesPaginated(this.currentPage, this.searcherCriteria));

    this.filteredInvoices = res.data;
    console.log('filteredInvoices: ', this.filteredInvoices);
    this.totalRecords = res.total_invoices;

    this.loading = false;
  }



  cancelInvoice(invoice: any) {
    this.apiService.post(`/invoices/cancel/${invoice.id}`, {})
      .subscribe(
        (response: any) => {
          console.log('response: ', response);
          setTimeout(() => {
            this.filteredInvoices = this.filteredInvoices.map((invoiceToUpdate: any) => {
              if (invoiceToUpdate.id == invoice.id) {
                invoiceToUpdate.reference_null = response.reference_null;
              }
              return invoiceToUpdate;
            });
          }, 0);
          this.cdr.detectChanges();
        },
        (error: any) => {

        }
      )
  }

  transformInvoiceNumber(invoiceNumber: any): string {
    return String(invoiceNumber || '').padStart(7, '0');
  }

  onSearchInput(event: any) {
    const searchText = event.target.value || '';
    if (typeof searchText === 'string') {
      this.searchSubject.next(searchText);
    }
  }

  download(id: number, invoice?: any, isOriginalInvoice = false) {
    let token = this.tokenService.getToken();

    if (!isOriginalInvoice) {
      window.open(`${environment.baseUrlWeb}/invoices/get/${id}?token=${token}`, '_blank');
    } else {
      window.open(`${environment.baseUrlWeb}/invoices/get/${id}?force_original=true&token=${token}`, '_blank');

    }

  }

  ngOnDestroy() {
    this.searchSubject.unsubscribe();
  }

}
